import {useDrawer} from "@/contexts/DrawerContext";
import {Button} from "@/components/ui/Button";
import {X} from "lucide-react";
import {DRAWER_IDS} from "@/components/Drawers";

const Sections = () => {
  const {Drawer, isDrawerOpen, closeDrawer} = useDrawer();
  const DRAWER_ID = DRAWER_IDS.SECTIONS;

  return (
    isDrawerOpen(DRAWER_ID) && (
      <Drawer id={DRAWER_ID} position="left" width="w-110">
        <div className="flex flex-col h-full">
          <div className="flex justify-between items-center gap-1 px-5 py-5 pb-4">
            <h2 className="text-base font-semibold text-ellipsis overflow-hidden whitespace-nowrap">
              Sections
            </h2>
            <Button
              variant="ghost"
              size="icon-sm"
              onClick={() => closeDrawer(DRAWER_ID)}
              className="[&_svg]:size-5"
            >
              <X />
            </Button>
          </div>
          <div className="space-y-4 max-h-full overflow-y-auto px-5 pb-5">
            Content
          </div>
        </div>
      </Drawer>
    )
  );
};

export default Sections;
